(() => {
  if (window.ceperaFitCollectionCaptions) {
    window.ceperaFitCollectionCaptions(document);
    return;
  }

  const captions = new Map();

  function fit(caption) {
    if (!caption.isConnected || !caption.clientWidth) return;
    const bounds = caption.getBoundingClientRect();
    const padding = parseFloat(getComputedStyle(caption).paddingRight);
    const walker = document.createTreeWalker(caption, NodeFilter.SHOW_TEXT);
    const range = document.createRange();
    let right = bounds.left;
    let node;

    while ((node = walker.nextNode())) {
      if (!node.textContent.trim()) continue;
      range.selectNodeContents(node);
      for (const rect of range.getClientRects()) {
        if (rect.width && rect.height) right = Math.max(right, rect.right);
      }
    }

    if (right > bounds.left) {
      // Fit only the painted background: balanced line breaks and layout stay fixed.
      const width = Math.min(bounds.width, Math.ceil(right - bounds.left + padding));
      caption.style.setProperty('--caption-background-width', `${width}px`);
    }
  }

  function scan(root) {
    root.querySelectorAll('.collection-banner__caption').forEach(caption => {
      if (captions.has(caption)) return;
      let frame;
      const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => fit(caption));
      };
      const observer = new ResizeObserver(schedule);
      observer.observe(caption);
      captions.set(caption, { schedule, dispose: () => {
        observer.disconnect();
        cancelAnimationFrame(frame);
      } });
      schedule();
    });
  }

  window.ceperaFitCollectionCaptions = scan;
  scan(document);
  document.fonts.ready.then(() => captions.forEach(state => state.schedule()));
  document.fonts.addEventListener('loadingdone', () => captions.forEach(state => state.schedule()));
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    captions.forEach((state, caption) => {
      if (event.target.contains(caption)) {
        state.dispose();
        captions.delete(caption);
      }
    });
  });
})();
